import React, { useState } from 'react';

import { IconButton, IconButtonProps, Tooltip } from '@material-ui/core';

import { FileCopyOutlinedIcon } from './style';

export interface CopyToClipboardComponentProps extends IconButtonProps {
  text: string;
}

export function CopyToClipboardComponent({ text, ...rest }: CopyToClipboardComponentProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  const copyDataToClipboard = () => {
    navigator.clipboard.writeText(text);
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 500);
  };

  return (
    <IconButton onClick={copyDataToClipboard} {...rest}>
      <Tooltip open={showTooltip} disableFocusListener disableHoverListener disableTouchListener title="Copied">
        <FileCopyOutlinedIcon />
      </Tooltip>
    </IconButton>
  );
}
